export const INTEGRATION_NAV_KEYS = [
    'eventival',
    'fiona',
    'kronos',
    'json',
    'ozu',
    'cinech',
    'maccsbox',
    'shift72',
    'pantaflix',
    'own_it',
    'como',
    'procinema',
    'mailchimp',
    'brevo',
    'getresponse',
    'gtm',
    'posthog',
    'plausible',
    'recaptcha',
    'wp',
    'weserv',
];

export const INTEGRATION_SUPERADMIN_KEYS = new Set(['weserv']);

export const INTEGRATION_SEARCH_KEYWORDS = {
    eventival: ['eventival'],
    fiona: ['fiona'],
    kronos: ['kronos', 'ticketack'],
    json: ['json'],
    ozu: ['ozu'],
    cinech: ['cinech', 'ciné.ch'],
    maccsbox: ['maccsbox', 'maccs', 'maccs box'],
    shift72: ['shift72', 'festival scope', 'festivalscope'],
    pantaflix: ['pantaflix'],
    own_it: ['own it', 'ownit', 'own_it'],
    como: ['como'],
    procinema: ['procinema', 'pro cinema', 'procinéma', 'voucher'],
    mailchimp: ['mailchimp'],
    brevo: ['brevo', 'sendinblue'],
    getresponse: ['getresponse', 'get response'],
    gtm: ['gtm', 'google tag manager', 'tag manager'],
    posthog: ['posthog', 'analytics', 'product analytics'],
    plausible: ['plausible', 'analytics', 'trafic', 'traffic', 'web analytics'],
    recaptcha: ['recaptcha', 'captcha'],
    wp: ['wordpress', 'wp'],
    weserv: ['weserv', 'proxy', 'cdn', 'images'],
};
